export const FEATURES = {
  OrgChart: 'orgChart',
  Directory: 'directory',
  Forecast: 'forecast',
  Scenarios: 'scenarios',
  AccessControl: 'accessControl',
  Hub: 'hub',
  Settings: 'settings',
  DataManagement: 'dataManagement',
  ExportData: 'exportData',
  Productivity: 'productivity',
  UserGroups: 'userGroups'
}
